/* import __COLOCATED_TEMPLATE__ from './data-section.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import templateOnlyComponent from '@ember/component/template-only';
import type EcommerceProduct from 'embercom/models/ecommerce-product';

interface Args {
  activeContent: EcommerceProduct;
}

const DataSection = templateOnlyComponent<Args>();
export default DataSection;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::ContentEditor::EcommerceProduct::DataSection': typeof DataSection;
    'knowledge-hub/content-editor/ecommerce-product/data-section': typeof DataSection;
  }
}
